import { useState } from 'react'

export function useVideoModalState (
  initialValue = { open: false, video: undefined }
) {
  const [videoState, setVideoState] = useState(initialValue)

  const handleChange = ({ open, video }) => {
    setVideoState({ open, video })
  }

  return {
    open: videoState.open,
    video: videoState.video,
    handleChange
  }
}
